/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { assert } from '@trello/error-handling';

import { CollectionView } from 'app/scripts/views/internal/CollectionView';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { ListView } from 'app/scripts/views/list/ListView';

// @ts-expect-error TS(2430): Interface 'ListListView' incorrectly extends inter... Remove this comment to see the full error message
interface ListListView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  resetCallback: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  viewType: any;
}

class ListListView extends CollectionView {
  static initClass() {
    this.prototype.viewType = ListView;
  }

  // @ts-expect-error TS(2416): Property 'initialize' in type 'ListListView' is no... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ resetCallback }: any) {
    this.resetCallback = resetCallback;
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super.initialize(...arguments);

    assert(this.resetCallback != null);

    this.listenTo(this.collection, {
      reset: this.resetCallback,
      'change:idBoard': this.boardChange,
    });
  }

  render() {
    const maxVisibleLists = Math.max(3, Math.ceil(window.innerWidth / 270)); // Hard coded list width

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const subviews = this.getModels().map((model: any, index: any) => {
      // @ts-expect-error TS(2554): Expected 0 arguments, but got 3.
      return this.subview(this.viewType, model, {
        deferCards: index >= maxVisibleLists,
      });
    });

    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    this.ensureSubviews(subviews);
    return this.resetCallback();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  boardChange(list: any, idBoard: any) {
    // @ts-expect-error
    if (idBoard === this.collection.board.get('id')) {
      return;
    }
    this.collection.remove(list);
    return DragSort.refreshIfInitialized(this.$el);
  }

  addModel() {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super.addModel(...arguments);
    return this.resetCallback();
  }

  removeSubview() {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super.removeSubview(...arguments);
    DragSort.refreshListCardSortable();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertSubview(subview: any) {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super.insertSubview(...arguments);
    if (subview.el.querySelectorAll('.ui-sortable').length > 0) {
      DragSort.refreshIfInitialized(this.$el);
    } else {
      DragSort.refreshListCardSortable();
    }
  }
}

ListListView.initClass();
export { ListListView };
